import React, { useEffect, useState } from "react";
import { BreadCrumbSecttion } from "../component/BreadCrumbSecttion";
import { Container, Row, Col, Button, Table } from "react-bootstrap";
import ThemeTable from "../component/ThemeTable";
import PurchaseService from "../services/Purchase";
import Loader from "../component/Loader";
import { useNavigate } from "react-router-dom";
import DatePicker from "../component/DatePicker";
import InputField from "../component/InputField";
import PrimaryGradientButton from "../component/PrimaryGradientButton";
import Form from "react-bootstrap/Form";
import PrimaryOutLineButton from "../component/PrimaryOutLineButton";
import toast from "react-hot-toast";
import SelectDropDown from "../component/SelectDropDown";
import { useMemo } from "react";
import NoData from "../component/NoData";
import OtherService from "../services/Other";
import GridModal2 from "../component/Modals/GridModal2";
const SchemeList = () => {
  const allStatus = [
    { id: "upcoming", title: "Upcoming" },
    { id: "previous", title: "Previous" },
  ];
  const userInfo = JSON.parse(localStorage.getItem("userData") || "{}");

  const isHierDesc = userInfo?.description || null;
  const [loading, setLoading] = useState(true);
  const [loadingDetails, setLoadingDetails] = useState(true);
  const [isSearchMobile, setIsSearchMobile] = useState("");
  const [isSearchName, setIsSearchName] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [isSearchPurchaseDate, setIsSearchPurchaseDate] = useState("");
  const [currentTab, setCurrentTab] = useState({ id: "upcoming", title: "Upcoming" });
  const [allData, setAllData] = useState([]);
  const [allList, setAllList] = useState([]);
  const [campList, setCampList] = useState([]);
  const [campListUpcoming, setCampListUpcoming] = useState([]);
  const [campDetails, setCampDetails] = useState(null);

  const handleCheckNow = (item) => {
    getDetails(item.campaignId)
  }
  const getList = async () => {
    const currentDate = new Date();
    // setLoading(true);
    const formatDate2 = dateString => {
        const date = new Date(dateString);
        const options = {
          day: '2-digit',
          month: 'short',
          year: 'numeric',
          // hour: '2-digit',
          // minute: '2-digit',
          // hour12: true,
        };
    
        return new Intl.DateTimeFormat('en-GB', options).format(date);
      };

    OtherService.campaignList()
      .then(res => {
        setLoading(false);
        if (res.response_code == 200) {
          const camplist=res.data;
          const format_data = camplist.map(item => ({
              endDate: item.endDate,
              startDate: item.startDate, 
            'Campaign ID': item.campaignId,
            'Scheme Name': item.campaignName,
            'Scheme Period': `${formatDate2(item.startDate)} - ${formatDate2(item.endDate)}`,
            'Description': item.frequency,
            'View Bonus Slides' : <button
                                    onClick={() => handleCheckNow(item)}
                                    className="checkNowBtn"
                                  >
                                    Check for details
                                  </button>
            // frequency: item.frequency,
            // searchTextDate: item.campaignName + ' ' + formatDate2(item.endDate)
          }));
        //   setAllList(format_data);
          const prevList = format_data.filter(item => {
                  const startDate = new Date(item.endDate);
                    return startDate < currentDate;
          }).map(item => ({ 'Campaign ID': item['Campaign ID'],
            'Scheme Name': item['Scheme Name'],
            'Scheme Period': `${formatDate2(item.startDate)} - ${formatDate2(item.endDate)}`,
            'Description': item['Description'],
        'View Bonus Slides': item['View Bonus Slides']}));
          setCampList(prevList);
          const upList = format_data.filter(item => {
            const startDate = new Date(item.endDate);
              return startDate >= currentDate;
    }).map(item => ({ 'Campaign ID': item['Campaign ID'],
        'Scheme Name': item['Scheme Name'],
        'Scheme Period': `${formatDate2(item.startDate)} - ${formatDate2(item.endDate)}`,
        'Description': item['Description'],
    'View Bonus Slides': item['View Bonus Slides']}));

    setCampListUpcoming(upList);
        } else {
          setCampList([]);
          const obj = res.response.error;
        }

      })
      .catch(err => {
        setLoading(false);
      });
  };

  const getDetails = async (id) => {
    setLoadingDetails(true);

    OtherService.campaignDetails(id)
      .then(res => {
        setLoadingDetails(false);
        if (res.response_code == 200) {
          setShowModal(true)
          setCampDetails(res.data);
        } else {
          setCampDetails('');
          const obj = res.response.error;
        }

      })
      .catch(err => {
        setLoadingDetails(false);
      });
  };

  useEffect(() => {
    if(currentTab.id == "upcoming") {
        setAllList([...campListUpcoming])
    } else {
        setAllList([...campList])
        
    }
  }, [currentTab])
  //Purchase List
//   const PurchaseListFetchData = async (
//     searchText,
//     fromDate,
//     toDate,
//     searchByInfName
//   ) => {
//     try {
//       const contactId = userInfo.dcm_contacts_id;
//       const brandId = userInfo.dcm_brands_id;
//       if (isHierDesc == "TSE") {
//         setTseSectionBlock(true);
//         // setLoading(false);
//       } else {
//         setTseSectionBlock(false);
//         // setLoading(false);
//       }

//       const payload = {
//         created_from: "",
//         created_to: "",
//         root_id: "",
//         search_type: "",
//         searchValue: "",
//         org_id: 2,
//         contact_id: Number(contactId),
//         contact_title: "",
//       };
//       // (brandId, mobNum, fromDate, toDate, listType, influencerName, payload, limit, pageNo)
//       const responsePurchaseList =
//         await PurchaseService.myPurchaseItemsUsingFilter(
//           isHierDesc === "TSE" ? "" : brandId,
//           searchText,
//           fromDate,
//           toDate,
//           status.id,
//           searchByInfName,
//           payload,
//           20,
//           status.pageNo
//         );

//       if (
//         responsePurchaseList.success == true &&
//         responsePurchaseList.response.status == true &&
//         responsePurchaseList.response.saleData.length > 0
//       ) {
//         const filteredData = responsePurchaseList.response.saleData.map(
//           (item, index) => {
//             const conumptionsData = item.proposed_area * conversionFactor;
//             let transationId = item.sale_id;
//             let quantityNo = Number(item.tonnage_sold);
//             let statusElement;
//             if (item.sale_status == 0) {
//               statusElement = (
//                 <>
//                   {isHierDesc != "TSE" && (
//                     <span className="pendingTxt">Submitted For Approval</span>
//                   )}
//                   {isHierDesc == "TSE" && (
//                     <div className="pendingStatusBlock">
//                       <span className="pendingTxt">Pending</span>
//                       <button
//                         onClick={() => handleCheckNow(item)}
//                         className="checkNowBtn"
//                       >
//                         Check
//                       </button>
//                     </div>
//                   )}
//                 </>
//               );
//             } else if (item.sale_status == 1) {
//               statusElement = (
//                 <div className="text-center approvedTxt">
//                   <span className="approvedTxt">Approved</span>
//                 </div>
//               );
//             } else if (item.sale_status == 2) {
//               statusElement = (
//                 <div className="text-center rejectedTxt">
//                   <span className="rejectedTxt">Rejected</span>
//                 </div>
//               );
//             }
//             const dateTime = new Date(item.created_at);
//             const formattedDateTime = dateTime.toLocaleString("en-US", {
//               year: "numeric",
//               month: "long",
//               day: "numeric",
//               hour: "numeric",
//               minute: "numeric",
//               second: "numeric",
//               hour12: true,
//             });

//             if (isHierDesc == "TSE")
//               return {
//                 // Select: (
//                 //   <input
//                 //     disabled={item.sale_status != 0}
//                 //     type="checkbox"
//                 //     id="scales"
//                 //     name="scales"
//                 //     checked={false}
//                 //     onChange={() => onChecked(item)}
//                 //   />
//                 // ),
//                 Select: {
//                   isChecked: false,
//                   saleStatus: item.sale_status,
//                   item: item
//                 },
//                 "Transaction Id": transationId,
//                 Quantity: quantityNo.toFixed(2),
//                 Description: item.product_description,
//                 "Purchase Date": item.sale_date,
//                 "Enrolled Date": formattedDateTime,
//                 "Proposed Area (Sq ft.)": item.proposed_area,
//                 "Approved Area (Sq ft.)":
//                   item.approved_area == null
//                     ? item.proposed_area
//                     : item.approved_area,
//                 "Total Conumptions (Bags)": conumptionsData,
//                 "Customer Name": item.customer_name,
//                 Dealer: (
//                   <div>
//                     {item.dealer_name}
//                     <span className="dealerId">{item.id_extern01}</span>
//                   </div>
//                 ),
//                 ...(tseSectionBlock && { "Purchased By": item.full_name }),
//                 Status: statusElement,
//               };
//             else {
//               return {
//                 "S No.": index + 1,
//                 "Transaction Id": transationId,
//                 Quantity: quantityNo.toFixed(2),
//                 Description: item.product_description,
//                 "Purchase Date": item.sale_date,
//                 "Enrolled Date": formattedDateTime,
//                 "Proposed Area (Sq ft.)": item.proposed_area,
//                 "Approved Area (Sq ft.)":
//                   item.approved_area == null
//                     ? item.proposed_area
//                     : item.approved_area,
//                 "Total Conumptions (Bags)": conumptionsData,
//                 "Customer Name": item.customer_name,
//                 Dealer: (
//                   <div>
//                     {item.dealer_name}
//                     <span className="dealerId">{item.id_extern01}</span>
//                   </div>
//                 ),
//                 ...(tseSectionBlock && { "Purchased By": item.full_name }),
//                 Status: statusElement,
//               };
//             }
//           }
//         );
//         setIsTableDataFound(true);
//         setIsDataFound(false);
//         if (status.pageNo == 1) setIsPurchaseList([...filteredData]);
//         if (status.pageNo > 1)
//           setIsPurchaseList((p) => [...p, ...filteredData]);
//         setLoading(false);
//         setIsSearchSingleData(false);
//       } else if (
//         responsePurchaseList.success == true &&
//         responsePurchaseList.response.status == true &&
//         responsePurchaseList.response.saleData.length == 0
//       ) {
//         // setIsTableDataFound(false);
//         toast.error("No more data available");
//         setIsSearchSingleData(true);
//         setBtnDisable(true);
//         setLoading(false);
//       } else {
//         setIsTableDataFound(false);
//         setIsSearchSingleData(true);
//         setLoading(false);
//       }
//     } catch (e) {
//       console.error("e");
//     }
//   };

  useEffect(() => {
    getList()
  }, [])

  const navigate = useNavigate();

  const handleSearchMobile = (e) => {
    setIsSearchMobile(e.target.value.replace(/\D/g, ""));
  };

  const handleSearchName = (e) => {
    setIsSearchName(e.target.value);
  };
  const handlePurchaseDate = (e) => {
    setIsSearchPurchaseDate(e.target.value);
  };
  const handleSearch = (type) => {
    if(type === "reset") {
      if(currentTab.id === 'upcoming')
        setAllList(campListUpcoming);
      else 
        setAllList(campList);
      return;
    }
    let filteredData = [];
    if(currentTab.id === 'upcoming')
      filteredData = campListUpcoming.filter(item => item['Scheme Name'].toLowerCase().includes(isSearchName.toLowerCase()));
    else 
      filteredData = campList.filter(item => item['Scheme Name'].toLowerCase().includes(isSearchName.toLowerCase()));
    setAllList(filteredData);
  };
  const handleClear = () => {
    // setIsPurchaseList([]);
    // setTimeout(() => {

      setIsSearchName("");
      handleSearch("reset")

    // }, 200)
  };

  

  let headers = [];
  if (allList.length > 0) {
    headers = Object.keys(allList[0]);
  }

  return (
    <>
      {/* {loading && <Loader />} */}

      <BreadCrumbSecttion
        pageTitle="Scheme List"
        currentPageName="Scheme List"
      />
      <section className="padTop50">
        <Container>
          <Row>
              <>
                {/* {tseSectionBlock && ( */}
                  <Col xs={12} lg={12}>
                    <div className="searchBoxBlock my-4">
                      <Row>
                        <Col xs={12} lg={3}>
                          <InputField
                            inputFieldLabel="Search By Name"
                            value={isSearchName}
                            onChange={handleSearchName}
                          />
                        </Col>
                         {/* <Col xs={12} lg={2}>
                          <Form.Label>Search By Purchase Date</Form.Label>
                          <Form.Control
                            type="date"
                            value={isSearchPurchaseDate}
                            onChange={handlePurchaseDate}
                          />
                        </Col> */}
                        <Col xs={12} lg={3}>
                          <SelectDropDown
                            labelName="Filter by status"
                            // requiredStar="*"
                            options={allStatus}
                            setSelectedValue={setCurrentTab}
                            selectedValue={currentTab}
                            // onChange={handleContentDistrictNameChange}
                            page="searchFilter"
                          />
                        </Col>
                        <Col xs={12} lg={3} className="mt-4">
                          <Row>
                            <Col xs={12} lg={6}>
                              <PrimaryGradientButton
                                buttonText="Search"
                                onClick={handleSearch}
                              />
                            </Col>
                            <Col xs={12} lg={6}>
                              <PrimaryOutLineButton
                                outlinebuttonText="Clear"
                                onClick={handleClear}
                              />
                            </Col>
                          </Row>
                        </Col>
                      </Row>
                    </div>
                  </Col>
                {/* )} */}

                {allList.length === 0 && !loading && <NoData />}
                {allList.length === 0 && loading && <NoData title="fetching.." />}
                {/* {isTableDataFound && ( */}
                  <Col xs={12} lg={12} className="purchaseListTable">
                    {/* <ThemeTable data={purchaseList} onLoadMore={onLoadMore} /> */}

                    <Table striped bordered hover responsive>
                      <thead>
                        <tr>
                          {headers.length > 0 &&
                            headers.map((header, index) => (
                              <th key={index}>{header}</th>
                            ))}
                        </tr>
                      </thead>
                      <tbody>
                        {allList.length > 0 &&
                          allList.map((item, index) => {

                            // const keysArray = Object.keys(item);
                            // return (
                            return (<tr
                              key={index}
                              // className={rowClickable ? "cursor-pointer" : ""}
                            >
                             {/* <td ><div>{index+1}</div>
                            </td> */}
                            <td
                            
                            >
                              <div>{item["Campaign ID"]}</div>
                            </td>
                            <td
                            
                            >
                              <div>{item["Scheme Name"]}</div>
                            </td>
                            <td
                            
                            >
                              <div>{item["Scheme Period"]}</div>
                            </td>
                            <td
                            
                            >
                              <div>{item["Description"]}</div>
                            </td>                  
                            <td
                            
                            >
                              <div>{item["View Bonus Slides"]}</div>
                            </td>                  
                            </tr>)
                          })}
                      </tbody>
                    </Table>
                  </Col>
                
              </>
            
          </Row>
        </Container>
      </section>
      <GridModal2 show={showModal} setShow={setShowModal} title={"Scheme Details"}>
        <Container>
          <Row>
            <Col xs={12} md={4}>
              <div className="grid-tab">Slab start</div>
            </Col>
            <Col xs={6} md={4}>
              <div className="grid-tab">Slab end</div>
            </Col>
            <Col xs={6} md={4}>
              <div className="grid-tab">Bonus</div>
            </Col>
          </Row>

          {campDetails?.productBonusSlabs.length > 0 && campDetails?.productBonusSlabs.map(item => {
            return (
              <Row>
              <Col xs={6} md={4}>
                <div className="grid-tab">{item.slab_start_range}</div>
              </Col>
              <Col xs={6} md={4}>
                <div className="grid-tab">{item.slab_end_range}</div>
              </Col>
              <Col xs={6} md={4}>
                <div className="grid-tab">{item.bonus}</div>
              </Col>
          </Row>
            );
          })}
        </Container>
      </GridModal2>
    </>
  );
};

export default SchemeList;
